/**
 * The site's own API proxy (/wp-json/ws/v1/, see includes/functions-api-proxy.php).
 * Third-party API keys stay on the server: the browser only ever calls this site.
 */
const base = typeof menaObject !== 'undefined' && menaObject.apiProxy ? menaObject.apiProxy : '/wp-json/ws/v1/';

/**
 * idGarages endpoint on the proxy.
 * @param {string} path e.g. 'makes', 'vins/VF1…'
 */
export function idgUrl(path) {
    return `${base}idg/${path}`;
}

/**
 * Azure image endpoint on the proxy.
 * @param {'read'|'dashboard'} name
 */
export function aiUrl(name) {
    return `${base}ai/${name}`;
}
